import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';

import { CmsService } from '@spartacus/core';
import { CmsComponentData } from '@spartacus/storefront';
import { combineLatest, Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { DpSocialItem } from '@app/core/types/backend/dp-social-item.interface';
import { DpSocial } from '@app/core/types/backend/dp-social.interface';

@Component({
    selector: 'dp-social',
    templateUrl: './social.component.html',
    styleUrls: ['./social.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class DpSocialComponent implements OnInit {
  items$!: Observable<DpSocialItem[]>;

  constructor(
    private readonly componentData: CmsComponentData<DpSocial>,
    private readonly cmsService: CmsService
  ) {}

  ngOnInit(): void {
    this.items$ = this.componentData.data$.pipe(
      switchMap((data) =>
        combineLatest(
          data.dpSocialMediaComponentItems
            .split(' ')
            .map((component) => this.cmsService.getComponentData<DpSocialItem>(component))
        )
      )
    );
  }
}
